export default __webpack_public_path__ + "static/media/hotel.4393f90d.svg";